export default __webpack_public_path__ + "static/media/Skirmisher's Staff.c94e0a98.jpg";